module.exports = __webpack_public_path__ + "static/media/YF52_5.4a47af19.jpg";